// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadRuntimeConfig } from './hooks/configLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));

// ==============================
// COMPONENTES DE BOOTSTRAP
// ==============================

const LoadingSplash = () => (
  <div style={{
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'sans-serif'
  }}>
    <div>Carregando configurações…</div>
  </div>
);

const CrashScreen = ({ error }) => (
  <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
    <h1>Ops! Não consegui carregar o config.json</h1>
    <p>Verifique o arquivo e tente novamente.</p>
    <pre style={{
      background: '#f7f7f7',
      padding: 12,
      borderRadius: 6,
      maxHeight: '40vh',
      overflow: 'auto'
    }}>
      {String(error?.message || error)}
    </pre>
  </div>
);

// ==============================
// VERIFICAÇÃO SILENCIOSA DE VERSÃO
// ==============================

const checkAppVersion = async () => {
  // try {
  //   const response = await fetch(`/version.json?ts=${Date.now()}`, {
  //     cache: 'no-store',
  //   });

  //   const data = await response.json();

  //   const CURRENT_VERSION = window._env_?.REACT_APP_VERSION || process.env.REACT_APP_VERSION;
  //   const STORAGE_KEY = 'app_version_checked';

  //   if (data.version !== CURRENT_VERSION) {
  //     const alreadyReloaded = sessionStorage.getItem(STORAGE_KEY);

  //     if (!alreadyReloaded) {
  //       sessionStorage.setItem(STORAGE_KEY, 'true');

  //       // Limpa possíveis caches
  //       if ('caches' in window) {
  //         const names = await caches.keys();
  //         await Promise.all(names.map((name) => caches.delete(name)));
  //       }

  //       window.location.href = window.location.origin + "?v=" + Date.now();
  //       return false;
  //     }
  //   }

  //   return true;
  // } catch (error) {
  //   console.warn('Falha ao verificar versão:', error);
    return true; // não bloqueia app se falhar
  // }
};

// ==============================
// BOOTSTRAP DA APLICAÇÃO
// ==============================

root.render(<LoadingSplash />);

(async () => {
  const canContinue = await checkAppVersion();

  if (!canContinue) return;

  loadRuntimeConfig()
    .then(() => {
      root.render(
        <Router>
          <App />
        </Router>
      );
    })
    .catch((error) => {
      console.error('Erro ao carregar config.json:', error);
      root.render(<CrashScreen error={error} />);
    });
})();